export default d=>new Promise(r=>setTimeout(r,d))